import { forecastDigestPayloadSchema } from '@lms/shared-types'
import type { ForecastDigestPayload } from '@lms/shared-types'
import { apiRequest } from './client'

export interface GetForecastDigestParams {
  hod_id: string
  window_days?: number
}

/**
 * Fetch a forecast digest for a given HOD.
 *
 * GET /api/v1/forecast/digest?hod_id=<uuid>&window_days=<n>
 *
 * Auth: HOD (own hod_id only), HR / Director / Exec Director (any hod_id).
 * Raises ApiError with status 401 / 403 on auth failures.
 */
export async function getForecastDigest({
  hod_id,
  window_days = 14,
}: GetForecastDigestParams): Promise<ForecastDigestPayload> {
  const raw = await apiRequest<unknown>(
    `/api/v1/forecast/digest?hod_id=${hod_id}&window_days=${window_days}`,
  )
  return forecastDigestPayloadSchema.parse(raw)
}
